// src/components/Layout/AdminLayout.js
import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import styles from './AdminLayout.module.css'; // CSS Module kullanımı

const AdminLayout = () => {
  return (
    <div className={styles.adminLayout}>
      <Sidebar />
      <div className={styles.mainContent}>
        <Header />
        <main className={styles.pageContent}>
          {/* Sayfa içeriği burada render edilecek */}
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;